import { createFileRoute, redirect } from '@tanstack/react-router';
import { DEFAULT_PROJECT_TAB } from '@/features/projects/search';

/** A project's bare address opens its first tab (the tab is always part of the address). */
export const Route = createFileRoute('/_auth/o/$orgId/projects/$projectId/')({
  beforeLoad: ({ params }) => {
    redirect({
      to: '/o/$orgId/projects/$projectId/$tab',
      params: { ...params, tab: DEFAULT_PROJECT_TAB },
      replace: true,
      throw: true,
    });
  },
});
